import { create } from "zustand";
// import { JobFilter } from "@domain/schemas/SO";
import { State } from "@progress/kendo-data-query";
import { JobListItemState } from "@presentation/common/types/extensions/JobListItemState";
import { Job } from "@domain/schemas/BI";

type SelectedState = { [id: string]: boolean | number[] };
interface JobListStore {
  // Local state of the UI like client-side filters, sorting, grouping, etc.
  metaState: State;
  setMetaState: (newMetaState: State) => void;

  selectedState: SelectedState;
  setSelectedState: (newSelectedState: SelectedState) => void;
  jobList: JobListItemState[];
  setJobList: (newJobList: Job[]) => void;
  setIsExpanded: (jobId: string, isExpanded: boolean) => void;

  // Server-side filters (unused for now)
  // filters: JobFilter;
  // setFilters: (newFilters: JobFilter) => void;
  setProgress: (id: string, progress: number) => void;
}

export const useJobListStore = create<JobListStore>((set) => ({
  metaState: {
    sort: [{ field: "createdAt", dir: "desc" }],
  },
  setMetaState: (newMetaState: State) => set({ metaState: newMetaState }),

  selectedState: {},
  setSelectedState: (newSelectedState: SelectedState) => set({ selectedState: newSelectedState }),

  jobList: [],

  setJobList: (newJobList: Job[]) => {
    set((state) => {
      const existingJobMap = new Map(state.jobList.map((job) => [job.id, job]));
      const updatedJobList = newJobList.map((job) => {
        const existingJob = existingJobMap.get(job.id);

        return {
          ...job,
          isSelected: existingJob ? existingJob.isSelected : false,
          isExpanded: existingJob ? existingJob.isExpanded : false,
          isFolder: existingJob && typeof existingJob.isFolder === "boolean" ? existingJob.isFolder : false,
        };
      });

      return { jobList: updatedJobList };
    });
  },

  setIsExpanded: (jobId: string, isExpanded: boolean) => {
    set((state) => {
      const updatedJobList = state.jobList.map((job) => (job.id === jobId ? { ...job, isExpanded } : job));
      return { jobList: updatedJobList };
    });
  },

  setProgress: (jobId: string, progress: number) => {
    set((state) => {
      const updatedJobList = state.jobList.map((job) => (job.id === jobId ? { ...job, progress } : job));
      return { jobList: updatedJobList };
    });
  },

  // filters: {} as JobFilter,
  // setFilters: (newFilters: JobFilter) => set({ filters: newFilters }),
}));
